import gql from 'graphql-tag';

export default gql`
  mutation SaveMacro($input: DailyTrackerSettingsInputType!) {
    dailyTracker {
      settings(input: $input) {
        ... on DailyTrackerSettingsSuccess {
          success
          message
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
      }
    }
  }
`;
